import { Component, OnInit } from '@angular/core';
import { PageNotFoundLabelEN } from '../models/labels/pageNotFound_EN';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss']
})
export class PagenotfoundComponent implements OnInit {
  label: PageNotFoundLabelEN;

  constructor() { }

  ngOnInit() {
    this.label = new PageNotFoundLabelEN();
  }

}
